<template>
  <div data-rmpdev-selector="redirect-modal">
    <span v-html="langIntro" />

    <p>Just enter your email below…</p>

    <form-input
      v-model="fields.email"
      :required="true"
      :error="validateStatus({ field: v$.fields.email, serverKey: 'email', label: 'Email' })"
      :manual-validate="validateAll"
      placeholder="Enter your email address"
      label="Your email"
      input-type="email"
      @change="validateBlur({ field: v$.fields.email, serverKey: 'email' })"
    />

    <div class="Form-field">
      <form-checkbox
          v-model="fields.courses_subscription"
          :value="1"
          label="Opt in to receive exclusive invites to our free Apprenticeship Accelerator. This two-part virtual event series provides all the tools you need to kickstart your career"
          data-rmpdev-field-selector="courses_subscription"
      />
    </div>

    <span v-html="langGdprStatement" />

    <div class="Buttons">
      <button
        class="Button Button--grey"
        @click.prevent="clickNo"
      >
        It’s not for me
      </button>
      <button
        :class="[{'is-loading': loading, 'spinner': loading }, 'Button Button--primary']"
        @click.prevent="clickYes"
      >
        Yes, sign me up!
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { required, email } from '@vuelidate/validators';

import ValidationMixin from '@/mixins/validation-mixin';
import FormInput from '@/components/form/input';
import useVuelidate from '@vuelidate/core';
import formCheckbox from '@/components/form/checkbox';

export default {

  components: {
    FormInput,
    'form-checkbox': formCheckbox,
  },
  mixins: [ValidationMixin],

  props: {
    redirectUrl: {
      type: String,
      default: '',
    },
    importComment: {
      type: String,
      default: 'Redirect Modal Popup',
    },
    langKey: {
      type: String,
      default: 'jobs',
    },
    jobId: {
      type: Number,
      default: null,
    },
  },

  setup() {
    return { v$: useVuelidate() };
  },

  data() {
    return {
      fields: {
        email: '',
        courses_subscription: false,
      },
      loading: false,
      serverValidationErrors: {},
      validateAll: false,
    };
  },

  computed: {
    langGdprStatement() {
      return this.$lang.redirectModals.gdprStatement;
    },
    langIntro() {
      return this.$lang.redirectModals[this.langKey].intro;
    },
  },

  validations() {
    const rules = {
      fields: {
        email: { required, email },
      },
    };

    return rules;
  },

  methods: {
    ...mapActions('user', {
      registerUser: 'registerUserWithoutPassword',
    }),

    clickYes() {
      if (this.loading) {
        return false;
      }

      this.v$.$validate();

      if (this.v$.fields.$invalid) {
        this.validateAll = true;
        return false;
      }

      this.serverValidationErrors = {};

      this.loading = true;

      const payload = {
        signin: true,
        jobs_subscription: 1,
        job_id: this.jobId,
        email: this.fields.email,
        courses_subscription: this.fields.courses_subscription,
        import_comment: this.importComment,
      };

      if (window.registrationTags) {
        payload.jobRoles = window.registrationTags.map((jobRole) => jobRole.tag_value);
      }

      // Perform Ajax request.
      return this.registerUser(payload)
        .then(() => {
          window.location.href = this.redirectUrl;
          this.serverValidationErrors = {};
          // Todo GA none added before
          this.$gtag.send({
            event: `${this.langKey}-redirect`,
            action: 'email-registration',
            category: 'redirect-tracking',
          });
          setTimeout(() => {
            this.loading = false;
          }, 500);
        })
        .catch((error) => {
          this.loading = false;

          if (error.status !== 200) {
            this.$bugsnag.notify(new Error('Redirect modal failure'), {
              severity: 'info',
              metaData: {
                'axios-error': error.data,
              },
            });
          }

          setTimeout(() => {
            window.location.href = this.redirectUrl;
          }, 500);
        });
    },

    clickNo() {
      this.$gtag.send({
        event: `${this.langKey}-redirect`,
        action: 'no-registration',
        category: 'redirect-tracking',
      });

      window.location.href = this.redirectUrl;
    },
  },
};
</script>
<style scoped lang="scss">

@import '../../../../scss/abstracts/abstracts.scss';
  .AuthRegister-optinCopy {
    margin-bottom: 1rem;
    margin-top: 1rem;
    font-size: 13px;
    font-size: 0.8rem;
  }
  .Buttons {
    display: flex;
    flex-wrap: wrap;

    @include respond-to(xs, max-width) {
      .Button {
        width: 100%;
        margin: 0 0 5px 0;
      }

      .Button.Button--primary {
        order: 1;
      }
      .Button.Button--grey {
        order: 2;
      }
    }
  }
</style>
